<template>
<div>
    <!-- modal -->
    <b-modal id="lawLedesExcelReadFormModal" centered size="lg" no-close-on-backdrop ref="lawLedesExcelReadFormModal" :title="$t('lawLedesExcelForm.title')" :cancel-title=" $t('others.cancel_title')" :ok-title=" $t('others.ok_title')" cancel-variant="outline-secondary" @ok.prevent="saveLawLedesExcel">
        <validation-observer ref="simpleRules">
            <!-- STOCK-2940 Yukleme oncesi beklenen kolon duzenini goster -->
            <b-row>
                <b-col class="col-12">
                    <div class="ledes-column-guide mb-1">
                        <div class="ledes-column-guide-title">{{ $t('lawLedesExcelForm.column_info_title') }}</div>
                        <table class="table table-sm table-bordered mb-1 ledes-column-guide-table">
                            <thead>
                                <tr>
                                    <th>A</th>
                                    <th>B</th>
                                    <th>C</th>
                                    <th>D</th>
                                    <th>E</th>
                                    <!-- STOCK-2972 Ucret Turu kolonu -->
                                    <th>F</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>{{ $t('lawLedesExcelForm.column_a') }}</td>
                                    <td>{{ $t('lawLedesExcelForm.column_b') }}</td>
                                    <td>{{ $t('lawLedesExcelForm.column_c') }}</td>
                                    <td>{{ $t('lawLedesExcelForm.column_d') }}</td>
                                    <td>{{ $t('lawLedesExcelForm.column_e') }}</td>
                                    <td>{{ $t('lawLedesExcelForm.column_f') }}</td>
                                </tr>
                            </tbody>
                        </table>
                        <small class="text-muted d-block">{{ $t('lawLedesExcelForm.column_info_note') }}</small>
                        <!-- STOCK-2972 Muhasebe Aciklamasi disindaki alanlar zorunlu -->
                        <small class="text-danger d-block mt-1">{{ $t('lawLedesExcelForm.required_note') }}</small>
                    </div>
                </b-col>
            </b-row>
            <b-row>
                <b-col class="col-lg-8">
                    <validation-provider #default="{ errors }" :name=" $t('lawLedesExcelForm.folder_name')" rules="required">
                        <label for="agent-annuity-folder-name-input">{{ $t('lawLedesExcelForm.folder_name') }}</label>
                        <b-input-group>
                            <b-form-input size="sm" id="folder-name-input" v-model="documentName" maxlength="50" :state="errors.length > 0 ? false:null" />
                            <b-input-group-append>
                                <b-button size="sm" variant="outline-primary" onclick="document.getElementById('lawLedesExcelFileSelect').click()">{{ $t('others.select') }}
                                </b-button>
                                <b-form-file size="sm" style="display:none" id="lawLedesExcelFileSelect" accept="*.*" @change="uploadLawLedesExcel" :placeholder=" $t('lawLedesExcelReadForm.select_folder')" :drop-placeholder=" $t('lawLedesExcelReadForm.select_folder_info')" />
                            </b-input-group-append>
                        </b-input-group>
                        <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                </b-col>

            </b-row>
        </validation-observer>
    </b-modal>
</div>
</template>

<script>
export default {
    props: {
        getLawServiceList: {
            type: Function
        },
    },
    data() {
        return {
            lawLedesId: 0,
            documentName: '',
            documentFile: '',
            documentType: '',
        }
    },
    methods: {
        showInfo(lawLedesId) {
            this.$refs['lawLedesExcelReadFormModal'].show()
            this.lawLedesId = lawLedesId
        },
        async uploadLawLedesExcel(e) {
            var fileInfo = await this.$getFileInfo(e.target.files[0])
            this.documentName = fileInfo.name
            this.documentType = fileInfo.contentType
            this.documentFile = fileInfo.base64
        },
        async saveLawLedesExcel() {
            this.$refs.simpleRules.validate().then(success => {
                const data = {
                    lawLedesId: this.lawLedesId,
                    base64File: this.documentFile,
                    documentType: this.documentType,
                    employeeId: localStorage.getItem('EmployeeId'),
                }

                const controller = {
                    name: 'LawLedes',
                    actionName: 'ReadLawLedesExcelFile'
                }
                const payload = {
                    data: data,
                    controller: controller
                }

                if (success) {
                    let loader = this.$loading.show()
                    this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
                        if (response.data.resultStatus == true) {
                            this.$bvModal.hide('lawLedesExcelReadFormModal')
                            this.$SaveAlert()
                            this.getLawServiceList()
                        } else {
                            this.showExcelErrors(response.data)
                        }
                        loader.hide()
                    }).catch((error) => {
                        // STOCK-2972 API hata durumunda 400 donuyor; axios bunu reject ediyor.
                        // Catch olmadan kullaniciya hicbir mesaj gosterilmiyordu, loader da acik kaliyordu.
                        loader.hide()
                        this.showExcelErrors(error.response != null ? error.response.data : null)
                    })
                }
            })
        },
        // STOCK-2972 Zorunlu alani eksik satirlari satir no ile listeler.
        showExcelErrors(data) {
            const errorList = data != null && data.excelErrorList != null ? data.excelErrorList : []
            if (errorList.length == 0) {
                this.$WarningAlert(data != null && data.resultMessage != null ? data.resultMessage : this.$t('lawLedesExcelForm.error_title'))
                return
            }
            const rowNoList = []
            const fieldsByRowNo = {}
            errorList.forEach(excelError => {
                if (fieldsByRowNo[excelError.rowNo] == null) {
                    fieldsByRowNo[excelError.rowNo] = []
                    rowNoList.push(excelError.rowNo)
                }
                fieldsByRowNo[excelError.rowNo].push(this.$t('lawLedesExcelForm.field_' + excelError.fieldKey))
            })
            const shownRowNoList = rowNoList.slice(0, 10)
            let message = '<p class="text-left">' + this.$t('lawLedesExcelForm.error_intro') + '</p><ul class="text-left">'
            shownRowNoList.forEach(rowNo => {
                message += '<li><b>' + this.$t('lawLedesExcelForm.error_row', { row: rowNo }) + ':</b> ' + fieldsByRowNo[rowNo].join(', ') + '</li>'
            })
            message += '</ul>'
            if (rowNoList.length > shownRowNoList.length) {
                message += '<p class="text-left">' + this.$t('lawLedesExcelForm.error_more', { count: rowNoList.length - shownRowNoList.length }) + '</p>'
            }
            const validCostingTypeList = data.validCostingTypeList != null ? data.validCostingTypeList : []
            if (validCostingTypeList.length > 0 && errorList.some(excelError => excelError.fieldKey == 'costingType')) {
                message += '<p class="text-left">' + this.$t('lawLedesExcelForm.valid_costing_types') + ' <b>' + validCostingTypeList.map(costingTypeName => this.escapeHtml(costingTypeName)).join(' / ') + '</b></p>'
            }
            this.$swal({
                title: this.$t('lawLedesExcelForm.error_title'),
                html: message,
                icon: 'warning',
                confirmButtonText: this.$t('lawLedesExcelForm.error_button'),
                customClass: {
                    confirmButton: 'btn btn-primary',
                },
                buttonsStyling: false,
            })
        },
        // Ucret Turu adlari DB'den geliyor, swal html olarak bastigi icin kacisliyoruz.
        escapeHtml(value) {
            const element = document.createElement('div')
            element.appendChild(document.createTextNode(value != null ? value : ''))
            return element.innerHTML
        },
    }
}
</script>

<style lang="scss">
[dir=ltr] .modal-header .close {
    margin: -0.4rem -0.4rem -0.8rem auto;
}

[dir] label {
    margin-bottom: 0.2857rem;
    font-weight: bold;
}

.modal .modal-content {
    overflow: visible;
    margin-bottom: auto;
}

[dir] .invalid-tooltip {
    padding: 0.4rem 0.775rem !important;
    margin-top: -1.5rem !important;
    background-color: #ea5455 !important;
    border-radius: 0.358rem !important;
    left: 20px !important
}

/* STOCK-2940 Excel kolon duzeni rehberi */
.ledes-column-guide {
    padding: 0.75rem;
    border: 1px solid #E5E7EB;
    border-radius: 0.358rem;
    background-color: #F9FAFB;
}

[dir] .ledes-column-guide-title {
    font-weight: bold;
    margin-bottom: 0.5rem;
}

.ledes-column-guide-table {
    font-size: 12px;
    background-color: #FFFFFF;
}

.ledes-column-guide-table th {
    /* STOCK-2972 F kolonu eklendi, 6 esit kolon */
    width: 16.66%;
    text-align: center;
    background-color: #F3F4F6;
}
</style>
